import EmailSentScreen from "./EmailSentScreen";

export default EmailSentScreen;
